'use client';

import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { format } from 'date-fns';
import { CommonLocals, formatDate, getUTCDate } from '@pioz/mlm-common';

export function Clock({
  locale,
  className,
  t,
}: {
  locale: CommonLocals;
  className?: string;
  t: { serverTime: string };
}) {
  const utcMode = process.env.NEXT_PUBLIC_UTC_DATE === 'true';

  const [date, setDate] = useState(utcMode ? getUTCDate() : new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setDate(utcMode ? getUTCDate() : new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={clsx(className)}>
      <div>{t.serverTime}:</div>
      <span suppressHydrationWarning className="font-mono">
        {formatDate(locale, date)} {format(date, 'HH:mm') + (utcMode ? ' UTC' : '')}
      </span>
    </div>
  );
}
